<template>
  <div class="wrap">
    <!-- <Header :class="`${fixedHeader ? 'fixedHeader' : 'absoluteHeader'}`" /> -->
    <Header :class="`${'fixedHeader'}`" />
    <div style="height: 60px"></div>
    <div class="main">
      <div class="title">
        {{$t('newsThreeTitle')}}
      </div>
      <!-- <span>{{$t('newsTime')}} 21-09-2017</span>
      <b>{{$t('newsThreeRead')}} 5.7w</b> -->
      <span>&nbsp;</span>
      <b>{{$t('newsThreeTime')}} 03-12-2021</b>
      <div class="banner" style="width: 60%; margin: 20px auto">
        <!-- <img src="../../assets/image/news/detail3.jpg" alt="" /> -->
      </div>
      <div class="content" v-for="(item,index) in $t('newsThreeDetail')" :key="index">
        <h4>{{item.h4}}</h4>
        <p>{{item.p}}</p>
        <!-- <p>
          Cash loan and consumer finance is really a big cake, attractive and
          delicious, a lot of capital bosses are also staring at this market,
          the competition is fierce, if not two brush, really can not play.
        </p>
        <p>
          Which brushes? One is capital, and the other is big data risk control.
        </p>

        <p>
          So, today we are going to talk about the big data risk control, is it
          reliable?
        </p>
        <p>
          Big data risk control, sounds so high, although don't know what it
          means, but just feel pretend bility.
        </p>
        <div class="banner" style="width: 60%; margin: 20px auto">
          <img src="../../assets/image/news/detail3.jpg" alt="" />
        </div>
        <h4>Big data risk control, what is it?</h4>
        <p>
          In fact, big data risk control is not mysterious, it is similar to the
          nature of traditional risk control, but more dimensions and
          correlation analysis are added to the risk control model.
        </p>
        <p>
          To take a simple example, traditional risk control, to judge whether a
          person is qualified for a loan, often checks his savings, income,
          collateral, family situation, credit status and so on. This type of
          credit risk management, also known as whitelisting, is where there are
          certain entry thresholds, and if you don't meet the requirements, then
          you can't apply for a loan.
        </p>
        <p>
          And big data risk control can reference data tend to be more rich,
          they will not only consider the financial data, also will introduce
          the social data of the borrowers, such as WeChat, weibo active state,
          focus on related topics and so on, pay data, such as purchasing power
          and spending habits, consumption amount, etc., and other life service
          class data, such as traffic data, eating habits, etc.
        </p>
        <p>
          Through these data, the economic image and social image of the
          applicant can be depicted more vividly, and the screening population
          base can be further expanded. This type of credit risk management,
          commonly known as blacklisting, creates minefields so long as you
          don't have those stains, you can apply for a loan.
        </p>
        <p>Sounds simple, but it doesn't feel like much.</p>
        <p>
          But in fact, big data risk control is of profound significance. It
          makes financial services more common and allows more ordinary people
          to enjoy such convenience.
        </p>
        <h4>Secure Multi-Party Computation</h4>
        <p>
          If we were to follow the strict requirements of traditional financial
          risk control, it is estimated that many readers would not be able to
          borrow money and enjoy financial services. Of course, this is not to
          say that you are inferior customer, it is to want to be old lai of,
          the possibility is just because you are white door, without what
          financial data can refer to, in order to avoid risk, can exclude you
          only.
        </p>
        <p>
          However, big data risk control is much more human, they will not only
          focus on a certain data of you, they will comprehensively measure your
          repayment ability, repayment willingness and so on, so as to give a
          more pertinent evaluation and loan amount.
        </p>
        <h4>Differential Privacy</h4>
        <p>
          The benefits of this approach are not only convenient for ordinary
          users to enjoy financial services, but also expand the capacity of the
          lending market and greatly promote the development of finance.
        </p>
        <p>
          However, big data risk control looks nice, but it is not easy to do.
        </p>
        <h4>First, the data should be comprehensive.</h4>
        <p>
          Big data does not mean that the amount of data should be large, but
          that data coverage should be comprehensive. Otherwise, no amount of
          irrelevant data will be of any use. Even dimensionality can be
          missing, as in judging whether someone is in good shape, knowing only
          their height, not their weight, is of no use?
        </p>
        <p>
          As far as I know, at present, there are some platforms in the online
          loan industry. Their so-called big data risk control is purely a
          display, which is of no use. The slogan is loud, but it has no
          practical significance.
        </p>
        <p>
          Fortunately, however, they are just a gimmick. If they are really
          trying to control risk based on incomplete big data, they will
          eventually die.
        </p>
        <h4>Then there is fraud prevention.</h4>
        <p>
          This common in personal credit loan, generally speaking, a person
          borrowed thousands of dollars, the platform is afraid of not he can
          not afford, but do not want to return, or even to cheat money. In
          other words, the borrower should not only have the ability to repay,
          but also have the willingness to repay, otherwise no matter how much
          money, it is not to receive back.
        </p>
        <p>
          This is the time to test the platform's risk control ability of big
          data. You have to distinguish which borrowers are old slackers and
          which are fraudsters from the vast number of borrowers.
        </p>
        <p>
          It was a challenge, especially when the platform was new and there
          were no data samples, and it was hard to avoid so many craters.
        </p>
        <p>
          More terrible is, the black industrial chain that still has a
          concealment in net loan industry -- cheat loan. Sometimes, through the
          platform's audit of a single borrower, the credit fraud army will dig
          out the loopholes in the whole big data risk control model of the
          platform and carry out large-scale loan fraud. Sometimes they collude
          with the platform's internal staff to commit fraud, which is simply
          impossible to guard against.
        </p>
        <h4>Finally, there is the issue of data freshness.</h4>
        <p>
          Big data should not only solve the problem of breadth, including all
          aspects of the borrower's economy and life behavior, but also solve
          the problem of depth, highlighting the related data of the borrower
          and focusing on depicting the image of the character.
        </p>
        <p>
          Breadth and depth are the basic framework of big data, but there is
          another point that cannot be ignored, that is the freshness of data.
        </p>
        <p>
          Freshness, natural data, the new the better, it is best to do constant
          monitoring, once the borrower overdue (or do not want to repay) bad
          signals, can take timely reminder, warning, collection and other
          emergency measures.
        </p>
        <p>
          Only when big data is reasonably and effectively used in all stages
          before, during and after the loan, can its real value be exerted and
          investors' funds be safeguarded.
        </p>
        <p>
          Of course, we should also understand that big data risk control is not
          a panacea. In the actual application process, we should continue to
          repair and improve in order to cope with the complex and changeable
          network lending environment.
        </p>
        <p>
          Well, let's stop here. Risk control of big data is a very complicated
          topic, which is difficult to be clear in a few words. If we have time
          and opportunity, we will discuss it again.
        </p>
        <p>
          As for how to judge whether the platform's big data risk control is
          reliable? It mainly depends on the bad debt rate of the platform, but
          the reality is very embarrassing. Most of the network loan platforms
          have been secretive about the overdue rate, so we can't know the real
          data.
        </p>
        <p>
          Therefore, we can only make a rough judgment based on the scale of the
          platform and the amount of funding. Generally speaking, the stronger
          the platform is, the better the data source will be obtained, and the
          more perfect the construction of risk control model will be, so the
          risk will be relatively small. Of course, this is not absolute, just
          as a reference.
        </p>
        <h4 style="textindex: 2rem">
          Another reminder is that big data risk control is mostly applied to
          personal credit loans and consumer finance, such as auto loans,
          corporate loans, housing loans and other asset side is not considered
          for the time being.
        </h4> -->
      </div>
        <h5 style="marginTop:26px">{{$t("newsTwoSource")}} https://www.detik.com/edu/perguruan-tinggi/d-5839180/bni-dukung-ipb-dorong-percepatan-campus-financial-ecosystem</h5>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "../../components/Header";
import Footer from "../../components/Footer";

export default {
  name: "Three",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      fixedHeader: false,
    };
  },
  created() {
    //获取滚动条高度处理头部导航
    window.onscroll = () => {
      // console.log(e)
      this.fixedHeader = document.documentElement.scrollTop >= 60;
    };
  },
};
</script>
<style lang="less" scoped>
.wrap {
  width: 100%;
  .fixedHeader {
    position: fixed;
    background: black;
  }
  .absolute {
    position: absolute;
  }
}
.banner {
  width: 100%;
  margin: 26px 0;
  img {
    width: 100%;
  }
}

.main {
  width: 60%;
  // background: linen;
  margin: auto;
  padding-top: 56px;
  padding-bottom: 80px;
  .title {
    // width: 80%;
    // margin: auto;
    // padding-top: 56px;
    font-size: 32px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #151515;
    margin-bottom: 18px;
    // display: flex;
    // align-items: center;
    // justify-content: center;
  }
  span {
    font-size: 13px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #8e8e8e;
  }
  b {
    font-size: 13px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #8e8e8e;
    font-weight: 400;
    margin-left: 60px;
    float: right;
  }
  h4 {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #071531;
    margin-top: 20px;
  }
  p {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #262626;
    margin-top: 20px;
    text-indent: 2em;
    line-height: 1.5;
  }

  //第一
  .first {
    background: #fff;
    width: 100%;
    padding-top: 40px;
  }
}
</style>